import React, { useState, useEffect } from 'react';

export const MultiSelect = props => {
    const [filter, setFilter] = useState("");

    const {
        title,
        selected,
        setSelected,
        origValues,
        options,
        resetFilter
    } = props;

    const [_options, setOptions] = useState(options.map(o => (
        {
            label: o.label.split(" ").map(str => {
                var initials = ["II", "III", "IV", "VI", "VII", "VIII", "VIII"];
                if (initials.some(ii => str == ii || str + "." == ii )) return str.toUpperCase();
                return str[0] ? (str[0].toUpperCase() + str.substring(1).toLowerCase()) : "";
        }).join(" "), value: o.value
        }
    )));
    const [isAscending, setIsAscending] = useState(true);

    const [currentItems, setCurrentItems] = useState([]);


    useEffect(_ => {
        var d = [..._options];
        d.sort((a, b) => isAscending ? a.label.toLowerCase() > b.label.toLowerCase() : a.label.toLowerCase() < b.label.toLowerCase());
        setOptions(d);
    }, [isAscending]);

    useEffect(_ => {
        setFilter("")
    },[resetFilter]);

    useEffect(_=>{
        if(filter == "") setCurrentItems(_options);
        else{
            var keywords = filter.split(" ");
            setCurrentItems(_options.filter(a => 
                {
                    var flag = false;

                    for(var i = 0; i < keywords.length;i++){
                        if(keywords[i] == "") continue;
                        if(a.label.toLowerCase().includes(keywords[i].toLowerCase())){
                            flag = true;
                        }
                        else{
                            flag = false;
                            break;
                        }
                    }
                    return flag;
                }
            ))
        }
    },[filter,_options])

    return <>
        { title }
        <div className="input-group mb-3">
            <span className="input-group-text" id="basic-addon1"><i className="fa fa-filter" /></span>
            <input value={filter} onChange={e => setFilter(e.target.value)} type="text" className="form-control" placeholder="Search.." aria-label="Username" aria-describedby="basic-addon1" />
            <i onClick={_ => setFilter("")} className={`fa fa-times clear-btn ${filter == "" ? "hide" : ""}`} />
        </div>
        <button className="btn btn-sm btn-light" onClick={_ => setIsAscending(a => !a)}>
            <i class={`fa fa-arrow-down-${isAscending ? "a-z" : "z-a"}`} />
            <span className="ms-2">Sort</span>
        </button>
        <div className="mt-1">
            <button className="btn btn-sm btn-primary"
                onClick={_ => setSelected(aa => {
                    return [...new Set(aa.concat(currentItems.map(a => a.value)))];
                }
                )}>
                <i className="fa fa-check mr-1" />
                {
                    filter == "" ? " Select All" : " Select All Filtered"
                }
            </button>
            <button className="btn btn-sm btn-danger mx-2" onClick={_ => {
                var results = currentItems.map(a => a.value);
                setSelected(aa => aa.filter(a => !results.includes(a)));
            }}>
                <i className="fa fa-times mr-1" /> Select None {filter != "" ? "(Filtered)" : ""}
            </button>
        </div>
        <hr className="my-2" />
        <div className="d-flex">
            <div>
                Selected: <span className="badge bg-success">{selected.length} of {_options.length}</span>
            </div>
            <div style={{marginLeft:"auto"} }>
                {
                    origValues ? <button style={{ fontSize: 12 }} className="btn btn-sm btn-secondary p-1" onClick={_ => setSelected(origValues)}>
                        <i className="fa fa-undo" /> Reset Changes</button> : ""
                }
            </div>
            
        </div>
        <hr className="my-2" />
        {
            filter != "" ? <>
                {currentItems.length} results from {_options.length} total entries
                <hr className="my-2" />
            </> : ""
        }
        <div style={{ maxHeight: 200, overflowY: "auto", padding: "5px 8px" }}>
            {
                currentItems.length == 0 ?
                    "No results found" : ""
            }
            {
                currentItems.map((a, i) => <div className="form-check" key={i}>
                    <input className="form-check-input" type="checkbox" value={a.value} id={`check-${i}`}
                        onChange={e => {
                            var value = parseInt(e.target.value);
                            if (e.target.checked) {
                                setSelected(aa => [...aa, value])
                            } else {
                                setSelected(aa => aa.filter(aaa => aaa != value))
                            }
                        }}
                        checked={selected.includes(a.value)} />
                    <label className="form-check-label" htmlFor={`check-${i}`}>
                        {a.label}
                    </label>
                </div>
                )
            }

        </div>
    </>
}